import config from 'config';
import { format } from 'date-fns';
import { OrderOutput } from 'gql/types';
import { ListTable } from 'modules/common/components';
import { ListTableDataType } from 'modules/common/types';
import UpsTrackingLink from 'modules/orders/components/UpsTrackingLink';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

type PropTypes = {
  order: OrderOutput;
};

const OrderInfoTable: FC<PropTypes> = ({ order }) => {
  const { t } = useTranslation('orders.OrderInfoTable');
  const { date, status, trackingCode } = order;

  const trackingValue = trackingCode
    ? trackingCode
        .split(',')
        .map((code) => (
          <UpsTrackingLink key={code} trackingCode={code.trim()} />
        ))
    : '-';

  const data = [
    {
      key: t('orderDate'),
      value: format(new Date(date), config.DATE_FORMATS.DATE),
    },
    {
      key: t('status'),
      value: status,
    },
    {
      key: t('trackingCode'),
      value: trackingValue,
    },
  ] as ListTableDataType[];

  return (
    <div className={styles.table}>
      <ListTable data={data} />
    </div>
  );
};

export default OrderInfoTable;
